<template>
    <div class="container" ref="container">
        <div class="main" :style="{transform:`translateY(${showNumberKey ? -300 : 0}px)`}">
            <div class="activity-cover">
                <van-image
                    height="100%" width="100%" fit="cover"
                    src="https://keyang2.tuzuu.com/uuo/ylh/18d1885b5e0c3fff2bcebf575f0efd7.png"/>
            </div>
            <div class="content">
                <!--            标题-->
                <div class="h-title">
                    {{ activityTitle }}
                </div>
                <div class="form-control" :style="{pointerEvents:`${shake ? 'none' : 'auto'}`}">
                    <div class="section-title flex-align">
                        <span>用户信息</span>
                        <div class="form-tip">请填写</div>
                    </div>
                    <van-form class="form-box" id="form" ref="formRef">
                        <van-field
                            v-model="form.user_name"
                            placeholder="必填, 请输入姓名"
                            label="姓名"
                            :rules="[{ required: true, message: '请输入姓名' }]">
                        </van-field>
                        <van-field
                            v-model.trim="form.tel"
                            placeholder="必填, 请输入联系电话"
                            label="联系电话"
                            type="tel"
                            maxlength="11"
                            clearable
                            :rules="[{ pattern: /^1\d{10}$/, message: '请填写正确的手机号' }]">
                        </van-field>
                        <van-field
                            v-model.trim="form.job_number"
                            placeholder="请输入工号"
                            label="工号"
                            maxlength="14"
                            :rules="[{ required: true, message: '请输入工号' }]"
                            clearable>
                        </van-field>
                        <select-mechan v-model="form.agency" :list="agencyList" @resetValidation="resetValidation"/>
                    </van-form>
                </div>
                <!--            金额-->
                <div class="price-control">
                    <div class="box-title flex-align">
                        <span>消费金额</span>
                    </div>
                    <div class="money" @click="openNumberKeyword">
                        <span>¥</span>
                        <div class="input">
                            <span v-if="showNumberKey || price">{{ price }}</span>
                            <span class="plac" v-else>请输入金额</span>
                            <div v-show="showNumberKey" class="cursor"></div>
                        </div>
                    </div>
                </div>
                <!--            订单列表-->
                <div class="pay-history-title" v-if="payList.length > 0">
                    我的支付记录
                </div>
                <div class="pay-list" v-if="payList.length > 0">
                    <div class="pay-item" v-for="item in payList" :key="item.id">
                        <div class="flex-between pay-item_title">
                            <div class="pay-item_title_1">订单信息</div>
                            <div class="pay-item_title_2">已支付</div>
                        </div>
                        <div class="pay-item-control">
                            <div class="pay-item_con">
                                <div class="pay-con_item flex-between">
                                    <div class="label">订单编号：</div>
                                    <div class="value">{{ item.sn }}</div>
                                </div>
                                <div class="pay-con_item flex-between">
                                    <div class="label">手机号：</div>
                                    <div class="value">{{ item?.tel || '无' }}</div>
                                </div>
                                <div class="pay-con_item flex-between">
                                    <div class="label">工号：</div>
                                    <div class="value">{{ item?.job_number || '无' }}</div>
                                </div>
                                <div class="pay-con_item flex-between">
                                    <div class="label">所属机构：</div>
                                    <div class="value">
                                        {{ getAgencyValue(item) || '无' }}
                                    </div>
                                </div>
                                <div class="pay-con_item flex-between">
                                    <div class="label">支付项目:</div>
                                    <div class="value">{{ item.title }}</div>
                                </div>
                                <div class="pay-con_item flex-between">
                                    <div class="label">应付金额:</div>
                                    <div class="value">¥{{ item?.order_price }}</div>
                                </div>
                                <div class="pay-con_item flex-between">
                                    <div class="label">实付金额:</div>
                                    <div class="value">¥{{ item?.pay_price }}</div>
                                </div>
                                <div class="pay-con_item flex-between">
                                    <div class="label">支付时间:</div>
                                    <div class="value">{{ item?.pay_at }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer ">
            <div class="footer-left">
                总计：
                <strong>
                    ¥<span>{{ price || '0.00' }}</span>
                </strong>
            </div>
            <div class="footer-right" @click="submit">
                立即支付
            </div>
        </div>
        <!--        数字键盘-->
        <van-number-keyboard :show="showNumberKey"
                             extra-key="."
                             maxlength="10"
                             v-model="price"
                             @blur="showNumberKey = false"/>
        <portal-target name="destination"></portal-target>
    </div>
</template>
<script>
import weChatPay from "@/wechat/weChatPay";
import weChatShare from "@/wechat/wxchatShare"
import selectMechan from "../componetns/selectMechan/index.vue";

export default {
    data() {
        return {
            agencyList: [],
            form: {
                user_name: '',
                tel: '',
                job_number: '',
                agency: {},
            },
            price: '',
            showNumberKey: false,
            payList: [],
            shake: false,  //防抖,true禁止
            activityTitle: '', //活动信息
            timer: true,//防止多次点击
        }
    },
    components: {
        selectMechan
    },
    created() {
        this.$toast.loading({
            forbidClick: true,
            message: '加载中'
        })
        Promise.all([
            this.$axios.get(
                "get_act_info", {
                    params: {
                        qrcode_id: this.$route.query.q_id,
                        type: 2
                    }
                }
            ),
            this.$axios.get("get_my_order", {params: {activity_id: this.$route.query.a_id}})
        ]).then((res) => {
            this.$toast.clear()
            if (res[0].code == 1) {
                this.activityTitle = res[0].data.name
                this.agencyList = res[0].data.agency
                //设置第二个
                this.payList = res[1].data
                document.title = this.activityTitle
                weChatShare({title: this.activityTitle})
            }
            if (res[0].code == 5001) {
                this.$router.push({path: '/end', query: {text: res[0].message}})
            }
        })
    },
    methods: {
        getAgencyValue(data) {
            let list = []
            if (data.agency_name_1) {
                list.push(data.agency_name_1)
            }
            if (data.agency_name_2) {
                list.push(data.agency_name_2)
            }
            if (data.agency_name_3) {
                list.push(data.agency_name_3)
            }
            return list.join("-")
        },
        openNumberKeyword() {
            this.$refs.container.scrollTop = 0
            this.showNumberKey = true
            this.shake = true
        },
        submit() {
            if (Number.isNaN(this.price) || Number(this.price) == 0) {
                this.$toast("请输入消费金额")
                return
            }
            this.$refs.formRef.validate().then(() => {
                this.$toast.loading({
                    forbidClick: true,
                    message: '微信支付中'
                })
                if (this.price.endsWith('.')) {
                    this.price = this.price + '00'
                }
                if (this.timer) {
                    this.timer = false
                    let query = this.$route.query
                    this.$axios.post("create", {
                        name: this.form.user_name,
                        tel: this.form.tel,
                        job_number: this.form.job_number,
                        agency_id_1: this.form.agency.id,
                        agency_id_2: this.form.agency.child.id || 0,
                        agency_id_3: (this.form.agency.child.child || {}).id || 0,
                        agency_name_1: this.form.agency.name || ' ',
                        agency_name_2: this.form.agency.child.name || ' ',
                        agency_name_3: (this.form.agency.child.child || {}).name || '',
                        pay_source: 2,
                        money: parseFloat(this.price),
                        remark: "",
                        activity_id: parseInt(query.a_id),
                        rec_qrcode_id: parseInt(query.q_id),
                        promoter_id: parseInt(query.p_id),
                        channel_id: parseInt(query.c_id),
                        salesman_id: parseInt(query.s_id),

                    }).then(res => {
                        this.timer = true
                        this.$toast.clear();
                        if (res.code == 1) {
                            let order_sn = res.data.order_sn
                            weChatPay({
                                wxPayConfig: res.data.payConfig,
                                onSuccess: () => {
                                    window.location.href = '/success?order_sn=' + order_sn
                                }
                            })
                        } else {
                            this.$toast(res.message)
                        }
                    })
                }

            })
        },
        resetValidation() {
            this.$refs.formRef.resetValidation("agency")
        }
    },
    watch: {
        showNumberKey() {
            if (!this.showNumberKey) {
                setTimeout(() => {
                    this.shake = false
                }, 300)
            }
        },
        price(value) {
            let num = value.match(/\./g)
            //当小数点超过两位，自动屏蔽
            if (num != null && num.length > 1) {
                this.price = value.slice(0, value.length - 1)
            }
            if (value.includes(".")) {
                //如果小数点在前，自动加0
                if (value.indexOf('.') == 0) {
                    this.price = '0.'
                }
                //限制小数点后两位
                let num = value.indexOf('.')
                let fixed = value.slice(num + 1)
                if (fixed.length > 2) {
                    this.price = value.slice(0, num + 1) + fixed.slice(0, 2)
                }
            }
            //如果以0开头，阻止连续输入两个0以上
            if (value.startsWith("00")) {
                this.price = '0'
            }
            //限制金额
            if (value.length > 7) {
                if (parseInt(value) > 9999999) {
                    this.price = value.slice(0, 7)
                }
            }
        }
    }
}
</script>
<style scoped lang="less">
.container {
    width: 100%;
    height: 100dvh;
    background-color: #efeff1;
    overflow: auto;
    padding-bottom: 20px;

    .activity-cover {
        width: 100%;
        padding-top: 68%;
        position: relative;

        &:before {
            content: '';
            display: block;
            width: 100%;
            height: 80px;
            position: absolute;
            bottom: -20px;
            z-index: 1;
            background: linear-gradient(180deg, rgba(247, 249, 251, 0) 0%, #EEF3F8 66%, #F2F5F6 100%);
        }

        .van-image {
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .content {
        transform: translateY(-60px);
        position: relative;
        z-index: 1;
        padding: 0 10px;

        .h-title {
            background: #FFFFFF;
            border-radius: 8px;
            padding: 20px 15px;
            font-size: 21px;
            font-weight: 700;
            color: #232323;
            line-height: 25px;
        }

        .form-control {
            padding: 15px 0;
            background: #FFFFFF;
            border-radius: 5px;
            margin-top: 10px;

            .section-title {
                padding: 8px 15px;
                font-family: "YouSheBiao", serif;
                color: #156BDC;
                font-size: 22px;
                background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(246, 249, 252, 0.85) 60%, #F4F8FB 100%);
            }

            .form-tip {
                font-size: 14px;
                font-weight: 500;
                color: #666666;
                background: #FFFFFF;
                padding: 3px 6px 1px;
                margin-left: 8px;
                line-height: 20px;
                border-radius: 50px 50px 50px 0px;
            }

            :deep(input) {
                background: transparent;
            }

            :deep(.van-cell) {
                .van-field__label {
                    color: #333333 !important;
                }

                font-size: 16px;
                background: transparent;
            }
        }

        .price-control {
            background: #FFFFFF;
            border-radius: 7px;
            overflow: hidden;
            margin-top: 10px;
            padding-bottom: 20px;

            .box-title {
                background: linear-gradient(360deg, rgba(252, 254, 255, 0) 0%, #D5EBFF 100%);
                padding: 14px 13px 4px;
                font-weight: bold;
                color: #156BDC;
                font-size: 18px;
                position: relative;

                img {
                    width: 22px;
                    margin-right: 6px;
                    position: relative;
                    z-index: 2;
                }

                span {
                    position: relative;
                    z-index: 2;
                }

                &:before, &:after {
                    content: '';
                    display: block;
                    width: 15px;
                    background: linear-gradient(360deg, #FCFDFF 0%, #F7FBFF 100%);
                    height: 130%;
                    position: absolute;
                    top: -15%;
                    transform: rotate(15deg);
                }

                &:before {
                    left: 12px;
                }

                &:after {
                    left: 40px;
                    background: linear-gradient(360deg, #FCFDFF 0%, rgba(247, 251, 255, 0.55) 100%);
                }
            }

            .money {
                border-bottom: 1px solid #f4f4f4;
                display: flex;
                align-items: center;
                margin: 20px 20px 0;
                padding-bottom: 10px;
                box-sizing: content-box;
                font-weight: 700;
                height: 32px;
                font-size: 27px;

                .input {
                    display: flex;
                    margin-left: 5px;
                    flex: 1;
                    height: 100%;

                    .plac {
                        font-size: 14px;
                        color: #666666;
                        font-weight: 400;
                        line-height: 32px;
                    }

                    .cursor {
                        width: 1px;
                        height: 100%;
                        background-color: #96dd8e;
                        margin-left: 2px;
                        animation: cursor 1s linear infinite;
                    }
                }

            }
        }

        //订单记录
        .pay-history-title {
            font-size: 19px;
            font-weight: bold;
            color: #156BDC;
            width: fit-content;
            margin: 20px 0px 18px;
            position: relative;

            &:before {
                content: '';
                display: block;
                background-image: url("https://keyang2.tuzuu.com/uuo/web/hainan/3279282a44788845698bdec0bf5ae423.png");
                position: absolute;
                bottom: -15px;
                left: 0;
                right: 0;
                margin: auto;
                width: 35px;
                height: 15px;
                background-size: 100% auto;
                background-repeat: no-repeat;
            }
        }

        .pay-item {
            background-color: white;
            margin: 10px 0px 0;
            border-radius: 5px;
            overflow: hidden;

            .pay-item_title {
                padding: 16px 10px 17px 13px;
                background: linear-gradient(360deg, rgba(2, 160, 255, 0) 0%, rgba(1, 103, 255, 0.09) 100%);

                .pay-item_title_1 {
                    font-weight: bold;
                    color: #232323;
                    letter-spacing: 0.5px;
                    font-size: 17px;
                }

                .pay-item_title_2 {
                    font-size: 15px;
                    font-weight: bold;
                    color: #156BDC;
                    background: #E7F1FF;
                    border-radius: 3px;
                    padding: 3px 7px;
                }
            }

            .pay-item-control {
                padding: 0 10px 0px 13px;
            }

            .pay-item_con {
                border-top: 1px solid rgba(226, 226, 226, 0.5);
                padding-bottom: 20px;
            }

            .pay-con_item {
                margin-top: 20px;

                .label {
                    color: #999999;
                    font-size: 14px;
                }

                .value {
                    font-size: 14px;
                    color: #232323;

                    span {
                        margin-left: 10px;
                    }
                }
            }
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 5;
        background: #FEFFFF;
        box-shadow: 0px 0px 7px 0px rgba(144, 144, 144, 0.21);
        padding: 7px 17px 7px 17px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .footer-left {
            font-size: 11px;
            color: #E42823;

            span {
                font-size: 22px;
                margin-left: 1px;
            }
        }

        .footer-right {
            background: linear-gradient(90deg, #FF6315 0%, #FD3F02 100%);
            border-radius: 23px;
            font-weight: bold;
            color: #FFFFFF;
            font-size: 16px;
            padding: 11px;
            width: 50%;
            text-align: center;
        }
    }

    /deep/ .van-cascader__options {
        height: 200px;
    }
}

@keyframes cursor {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 1;
    }
    55% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
}
</style>